// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'user';

export const Component = () => (
  <path d='M8.5 7.476c0 1.121.39 2.048 1.171 2.83.78.78 1.708 1.17 2.83 1.17s2.049-.39 2.83-1.17c.78-.782 1.17-1.709 1.17-2.83 0-1.074-.39-2-1.17-2.83-.781-.78-1.708-1.17-2.83-1.17s-2.05.39-2.83 1.17c-.78.83-1.17 1.756-1.17 2.83Zm-.975 0c0-1.366.488-2.537 1.464-3.513C9.964 2.988 11.135 2.5 12.5 2.5c1.365 0 2.536.488 3.512 1.463.976.976 1.463 2.146 1.463 3.513 0 1.414-.487 2.585-1.463 3.56-.976.976-2.146 1.464-3.512 1.464s-2.537-.488-3.512-1.464c-.976-.975-1.464-2.146-1.464-3.56ZM20.5 22.499h-1.024v-1.024c0-1.95-.683-3.61-2.049-4.975-1.317-1.317-2.975-2-4.927-2-1.903 0-3.56.683-4.927 2.049-1.365 1.317-2.049 2.975-2.049 4.927V22.5H4.5v-1.024c0-2.195.78-4.049 2.342-5.61 1.56-1.61 3.463-2.39 5.658-2.39 2.195 0 4.097.78 5.658 2.342 1.561 1.56 2.342 3.463 2.342 5.658V22.5Z' />
);

export const viewBox = '0 0 25 25';
